import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

const PrivateRoute = (props) => {
  const { loggedIn, children } = props;
  const location = useLocation();

  return loggedIn ? children : <Navigate to="/login" replace state={{ from: location }} />;
}

const mapStateToProps = (state) => {
  return {
    loggedIn: state.session.loggedIn,
  };
};

export default connect(mapStateToProps)(PrivateRoute);
